module.exports = {
  'ar': require('./lang/ar.json'),
  'bg': require('./lang/bg.json'),
  'ca': require('./lang/ca.json'),
  'cs': require('./lang/cs.json'),
  'da': require('./lang/da.json'),
  'de': require('./lang/de.json'),
  'el': require('./lang/el.json'),
  'en': require('./lang/en.json'),
  'es': require('./lang/es.json'),
  'fa': require('./lang/fa.json'),
  'fi': require('./lang/fi.json'),
  'fr': require('./lang/fr.json'),
  'hr': require('./lang/hr.json'),
  'hu': require('./lang/hu.json'),
  'it': require('./lang/it.json'),
  'ja': require('./lang/ja.json'),
  'ko': require('./lang/ko.json'),
  'nb': require('./lang/nb.json'),
  'nl': require('./lang/nl.json'),
  'nn': require('./lang/nn.json'),
  'pl': require('./lang/pl.json'),
  'pt-BR': require('./lang/pt-BR.json'),
  'ru': require('./lang/ru.json'),
  'sr': require('./lang/sr.json'),
  'sv': require('./lang/sv.json'),
  'tr': require('./lang/tr.json'),
  'uk': require('./lang/uk.json'),
  'vi': require('./lang/vi.json'),
  'zh-CN': require('./lang/zh-CN.json'),
  'zh-TW': require('./lang/zh-TW.json')
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/languages.js
// module id = ktPO
// module chunks = 0